export default "__VITE_ASSET__7081d7b0__"